<template>
  <div class="container">
    <div class>
      <div class="mt-100 container-style mb-100">
        <studyFeatureHeader></studyFeatureHeader>
        <div class="p-20">
          <div class>
            <div class="fw-500 fs-24">Schedule your survey</div>
            <div class="pt-20 mb-22 clearfix survey_qs">
              How would you like your activity to be sent?
            </div>
            <span class="activity-mode">
              <span :class="{ selected: activityMode === 'schedule' }" @click="changeActivityMode('schedule')"><img :src="activityModeIcon['schedule']" width="29" />&nbsp;&nbsp;Scheduled</span>
              <span :class="{ selected: activityMode === 'both' }" @click="changeActivityMode('both')"><img :src="activityModeIcon['both']" width="58" />&nbsp;&nbsp;Both scheduled and on-demand</span>
              <span :class="{ selected: activityMode === 'onDemand' }" @click="changeActivityMode('onDemand')"><img :src="activityModeIcon['onDemand']" width="29" />&nbsp;&nbsp;On-demand only</span>
            </span>
            <div :class="{ 'activity-mode-opacity': activityMode === 'onDemand' }" class="pt-20 clearfix survey_qs" v-if="activityMode">
              Which method would you like to schedule with?
            </div>
            <schedulerComponent :class="{ 'activity-mode-opacity': activityMode === 'onDemand' }" :options="{ validateFor: 'survey', activityMode: activityMode }" v-if="activityMode"></schedulerComponent>
          </div>
          <div class="bt-1" v-if="activityMode != 'onDemand'">
            <div class="row pt-20">
              <div class="fw-500 fs-24">Additional settings</div>
            </div>
            <div class="row pt-20">
              <label class="switch">
                <input type="checkbox" v-model="prePopulationEnabled" v-on:change="changeStatus" />
                <div class="slider round"></div>
              </label>
              <div class="pl-10">
                Show participant's their previous survey answers, if applicable. Only applies for this survey.
              </div>
            </div>
          </div>
          <div class="divider"></div>
          <div class="email-div">
            <div class="heading">Email recipient</div>
            <div class="email-div1">
              <div class="txt">Questions and answers included:</div>
              <div v-if="questions.length > 0">
                <div class="txt1" v-for="(question, index) in questions" :key="index">• {{ question }}</div>
              </div>
              <div class="txt1" v-if="questions.length == 0">• None</div>
            </div>
            <div class="email-div2" v-if="notifyToEmail">
              <div class="heading">Sent to:</div>
              <div>
                <label class="fw-normal">
                  <input @click="notificationRecipient($event)" type="checkbox" v-model="sentToTeam" name="sentToTeam" class="checkbox_position" />
                  <span class=""> Send notifications to the Site Team.</span>
                </label>
                <span class="fa fa-info-circle info-circle pl-10 pt-10" aria-hidden="true" @click="toggleInfo()" @blur="hideInfo()" tabindex="-1"></span>
                <div class="info-circle-div site-team" v-show="infoDiv">
                  The notifications will be sent to Site Team which include Principal Investigator, Sub-Investigator, and Study Coordinator, if applicable.
                </div>
              </div>
              <div class="mt-20">And/or other recipients:</div>
              <div class="input">
                <input
                  type="text"
                  placeholder="Enter email"
                  v-model="surveyNotificationEmail.email"
                  v-on:keyup="validateParticipants"
                  v-validate="'required|email'"
                  :name="`email`"
                  :class="{
                    'is-danger': emailError,
                    'is-success': !emailError
                  }"
                />
                <button class="add left-margin" v-on:click="addNotificationEmail()" :disabled="!addRecipientBtn" :class="{ recipientBtnDisabled: !addRecipientBtn }">
                  Add recipient
                </button>
                <span v-show="emailError" class="error-style">Please enter a valid email address.</span>
                <span v-show="alreadyExists" class="error-style">This email address already exists.</span>
              </div>
            </div>
            <div class="email-div3" v-if="notifyToEmail">
              <div class="txt" v-for="(item, index) in emails" :key="index">
                {{ item.email }}
                <span class="txt-remove" v-on:click="removeEmail(item.email)">Remove</span>
              </div>
            </div>
          </div>
          <div class="pt-40 mb-50">
            <span class="back_link" v-on:click="goBack()"> <i class="fa fa-caret-left" aria-hidden="true"></i> Back </span>
          </div>
        </div>
        <div class="footerStyle">
          <div class="container">
            <div class="row">
              <button class="btn br-25 disable-btn mr-10" v-on:click="skipForNow()">
                Skip for now
              </button>
              <button class="btn nextBtn br-25" v-on:click="validateScheduler()">
                Save and Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import toastr from "toastr";
// import _ from "lodash";
import studyFeatureHeader from "../common/study-features-header";
import schedulerComponent from "../common/scheduler";
import swal from "sweetalert2";
import _ from "lodash";
import { saveAuditDetails } from "../configurator/util/saveAuditDetails";

const MODE_ICON = {
  schedule: {
    selected: "static/img/selected-scheduled-activity-icon.svg",
    unselected: "static/img/scheduled-activity-icon.svg"
  },
  both: {
    selected: "static/img/selected-scheduled-and-on-demand-activity.svg",
    unselected: "static/img/scheduled-and-on-demand-activity.svg"
  },
  onDemand: {
    selected: "static/img/selected-on-demand-activity-icon.svg",
    unselected: "static/img/on-demand-activity-icon.svg"
  }
};

export default {
  name: "scheduler",
  data() {
    return {
      infoDiv: false,
      addRecipientBtn: false,
      alreadyExists: false,
      emailError: false,
      surveyNotificationEmail: {
        email: "",
        studyId: ""
      },
      emails: [],
      questions: [],
      notifyToEmail: false,
      studyId: null,
      surveyId: null,
      studyData: {},
      surveyData: {},
      milestones: [],
      frequencies: [
        { type: "daily", title: "Daily", days: 1 },
        { type: "weekly", title: "Weekly", days: 7 },
        { type: "biweekly", title: "Every 2 Weeks", days: 15 },
        { type: "monthly", title: "Monthly", days: 30 },
        { type: "biannually", title: "Bi-annually", days: 180 },
        { type: "annually", title: "Annually", days: 360 }
      ],
      questionAnswers: [],
      scheduler: {
        type: "milestone",
        milestones: [],
        frequency: {},
        startDay: null,
        endDay: null,
        completionWindow: null,
        reminders: [{}],
        allowMultipleTimes: false,
        allowUntillDuration: false
      },
      exampleMileStone: [
        { date: "Day1", day: "Wed", class: "bg-green" },
        { date: "Day2", day: "Thur", class: "" },
        { date: "Day3", day: "Fri", class: "" },
        { date: "+2", day: "Sat", class: "bg-red" }
      ],
      prePopulationEnabled: false,
      sentToTeam: null,
      activitySchedulingMode: "",
      activityModeIcon: {
        schedule: MODE_ICON.schedule.unselected,
        both: MODE_ICON.both.unselected,
        onDemand: MODE_ICON.onDemand.unselected
      },
      autoSaveElementTimeout: process.env.VUE_APP_AUTO_SAVE_ELEMENT_LIB_TIMEOUT,
      previousSurveySchedular: {},
      previousPrePopulationEnabled: false,
      previousSentToTeam: false
    };
  },
  components: { studyFeatureHeader, schedulerComponent },
  mounted() {
    this.studyId = this.$route.params.studyId;
    this.surveyId = this.$route.params.surveyId;
    this.getStudyDetails();
    this.getSurveyDetails();
    this.getNotificationEmail();
    this.isQuestionEmail();
    this.getRecipientFlag();
    this.startAutoSave();
  },
  computed: {
    schedulerObjChanged() {
      return this.$store.getters.getSchedulerObjData;
    },
    activityMode: {
      get: function() {
        return this.activitySchedulingMode;
      },
      set: function(mode) {
        this.activitySchedulingMode = mode;
      }
    }
  },
  watch: {
    schedulerObjChanged: {
      handler(val, oldValue) {
        if (val.validatedFor === "survey") {
          if (oldValue.autoSave) {
            this.addScheduler(val.schedulerObj, val.schedulerObjOld, oldValue.autoSave);
          } else {
            this.addScheduler(val.schedulerObj, val.schedulerObjOld);
          }
        }
      }
    }
  },
  methods: {
    getRecipientFlag() {
      this.$api.getRecipientFlag(this.studyId, this.surveyId).then(
        response => {
          this.sentToTeam = response.body && response.body.isNotificationRecipient ? response.body.isNotificationRecipient : false;
          this.previousSentToTeam = _.cloneDeep(this.sentToTeam);
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while getting the study details");
        }
      );
    },
    notificationRecipient(ele) {
      this.sentToTeam = ele.target.checked;
      this.$api
        .configuredRecipient(this.surveyId, {
          studyId: this.studyId,
          surveyId: this.surveyId,
          isNotificationRecipient: ele.target.checked
        })
        .then(
          response => {
            saveAuditDetails(this.$api, this.studyId, {
              section: "Customize",
              element: "Notification Recipient",
              httpMethod: "POST",
              url: response.url.substring(response.url.indexOf("/api")),
              changeFrom: { studyId: this.studyId, surveyId: this.surveyId, isNotificationRecipient: !ele.target.checked },
              changeTo: { studyId: this.studyId, surveyId: this.surveyId, isNotificationRecipient: ele.target.checked }
            });
            this.sentToTeam = response.body && response.body.isNotificationRecipient ? response.body.isNotificationRecipient : false;
            this.previousSentToTeam = _.cloneDeep(this.sentToTeam)
          },
          error => {
            toastr.error(error.body ? error.body.message : "Error while configuring recipient");
          }
        );
    },
    getAPIUrl(url) {
      return url.substring(url.indexOf("/api"));
    },
    validateParticipants() {
      if (this.surveyNotificationEmail.email === "" || this.surveyNotificationEmail.email === null) {
        this.emailError = false;
        this.alreadyExists = false;
        this.addRecipientBtn = false;
      } else if (this.validateEmail(this.surveyNotificationEmail.email) === false) {
        this.emailError = true;
        this.alreadyExists = false;
        this.addRecipientBtn = false;
      } else if (this.isEmailExists(this.surveyNotificationEmail.email) === true) {
        this.emailError = false;
        this.alreadyExists = true;
        this.addRecipientBtn = false;
      } else {
        this.emailError = false;
        this.alreadyExists = false;
        this.addRecipientBtn = true;
      }
    },
    removeEmail(email) {
      swal({
        title: "Are you sure you want to remove?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#f16559",
        confirmButtonText: "Cancel",
        cancelButtonText: "Remove"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.surveyNotificationEmail.studyId = this.studyId;
          this.surveyNotificationEmail.email = email;
          this.$api.removeEmail(this.surveyId, this.surveyNotificationEmail).then(
            response => {
              saveAuditDetails(this.$api, this.studyId, {
                section: "Customize",
                element: "Email Recipient",
                httpMethod: "DELETE",
                url: response.url.substring(response.url.indexOf("/api")),
                changeFrom: this.emails,
                changeTo: response.body
              });
              this.emails = response.body;
              this.surveyNotificationEmail.email = "";
              this.emailError = false;
              this.alreadyExists = false;
              this.addRecipientBtn = false;
            },
            error => {
              toastr.error(error.body ? error.body.message : "Error while getting the study details");
            }
          );
        }
      });
    },
    getNotificationEmail() {
      this.$api.getNotificationEmails(this.surveyId, this.studyId).then(
        response => {
          this.emails = response.body;
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while getting the study details");
        }
      );
    },
    addNotificationEmail() {
      if (this.surveyNotificationEmail.email === "" || this.surveyNotificationEmail.email === null) {
        this.emailError = false;
        this.alreadyExists = false;
        this.addRecipientBtn = false;
      } else if (this.validateEmail(this.surveyNotificationEmail.email) === false) {
        this.emailError = true;
        this.alreadyExists = false;
        this.addRecipientBtn = false;
      } else if (this.isEmailExists(this.surveyNotificationEmail.email) === true) {
        this.emailError = false;
        this.alreadyExists = true;
        this.addRecipientBtn = false;
      } else {
        this.emailError = false;
        this.alreadyExists = false;
        this.addRecipientBtn = true;
        this.surveyNotificationEmail.studyId = this.studyId;
        this.$api.addEmailForNotification(this.surveyId, this.surveyNotificationEmail).then(
          response => {
            saveAuditDetails(this.$api, this.studyId, {
              section: "Customize",
              element: "Email Recipient",
              httpMethod: "POST",
              url: response.url.substring(response.url.indexOf("/api")),
              changeFrom: this.emails,
              changeTo: response.body
            });
            this.emails = response.body;
            this.surveyNotificationEmail.email = "";
            this.addRecipientBtn = false;
          },
          error => {
            toastr.error(error.body ? error.body.message : "Error while getting the study details");
          }
        );
      }
    },
    isEmailExists(email) {
      const e = this.emails;
      let result = false;
      for (let i = 0; i < e.length; i++) {
        if (e[i].email === email) {
          result = true;
        }
      }
      return result;
    },
    validateEmail(email) {
      const re = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      return re.test(email);
    },
    isQuestionEmail() {
      let temp = this.notifyToEmail;
      const q = this.questions;

      this.$api.getSurveyDetailsFact(this.studyId, this.surveyId).then(
        response => {
          response.body.questions.map(function(value) {
            if (value.isNotifyToEmail) {
              temp = true;
              q.push(value.body);
            }
          });
          this.notifyToEmail = temp;
          this.questions = q;
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while getting the survey details");
        }
      );
    },
    goBack() {
      window.history.back();
    },
    skipForNow() {
      this.$router.push({
        name: "survey-review",
        params: { studyId: this.studyId, surveyId: this.surveyId }
      });
    },
    validateScheduler(autoSave = false) {
      if (this.notifyToEmail) {
        if (this.emails.length != 0 || this.sentToTeam) {
          if (!autoSave) {
            this.$store.dispatch("addSchedule", { validateFor: "survey" });
          } else {
            this.$store.dispatch("addSchedule", {
              validateFor: "survey",
              autoSave: autoSave
            });
          }
        } else {
          if (!autoSave) {
            toastr.error("Please enter at least one email recipient.");
          }
        }
      } else {
        if (!autoSave) {
          this.$store.dispatch("addSchedule", { validateFor: "survey" });
        } else {
          this.$store.dispatch("addSchedule", {
            validateFor: "survey",
            autoSave: autoSave
          });
        }
      }
    },
    getSurveyDetails() {
      this.$api.getSurveyDetailsFact(this.studyId, this.surveyId).then(
        response => {
          this.surveyData = response.body;
          this.prePopulationEnabled = response.body.prePopulationEnabled;
          this.previousPrePopulationEnabled = _.cloneDeep(this.prePopulationEnabled);
          this.scheduler = response.body.scheduler ? response.body.scheduler : this.scheduler;
          this.previousSurveySchedular = _.cloneDeep(this.scheduler);
          if (response.body.scheduler) {
            this.activityMode = this.surveyData.scheduler.activitySchedulingMode;
          } else {
            this.activityMode = "schedule";
          }
          this.setActivityModeIcon(this.activityMode);
          this.$store.dispatch("setSurveyDetailsAction", response.body);
          if (this.surveyData.questions && this.surveyData.questions.length > 0) {
            this.timeToComplete = this.surveyData.timeToComplete;
            this.questionAnswers = response.body.questions;
          }
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while getting the survey details");
        }
      );
    },
    getStudyDetails() {
      this.$api.getStudyDataFact(this.studyId).then(
        response => {
          this.studyData = response.body;
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while getting the study details");
        }
      );
    },
    addScheduler(scheduleObj, scheduleObjOld, autoSave = false) {
      this.$api.postSchedulingFact(this.studyId, scheduleObj).then(
        response => {
          const auditDetails = {
            section: "Customize",
            element: "Surveys",
            httpMethod: "PUT",
            url: this.getAPIUrl(response.url),
            changeFrom: scheduleObjOld || this.previousSurveySchedular,
            changeTo: scheduleObj
          };
          saveAuditDetails(this.$api, this.studyId, auditDetails);
          // Lets update the previous state
          this.previousSurveySchedular = {};

          if (!autoSave) {
            toastr.success("Scheduling completed successfully");
            this.$router.push({
              name: "survey-review",
              params: { studyId: this.studyId, surveyId: this.surveyId }
            });
          }
        },
        error => {
          if (!autoSave) {
            toastr.error(error.body ? error.body.message : "Error while the scheduling the survey");
          }
        }
      );
    },
    changeStatus() {
      const data = {};
      data.prePopulationEnabled = this.prePopulationEnabled;
      this.$api.updateSurveyPrepopulationFact(this.surveyId, this.studyId, data).then(
        response => {
          const auditDetails = {
            section: "Customize",
            element: "Surveys",
            httpMethod: "POST",
            url: this.getAPIUrl(response.url),
            changeFrom: { prePopulationEnabled: this.prePopulationEnabled },
            changeTo: { prePopulationEnabled: this.previousPrePopulationEnabled }
          };
          saveAuditDetails(this.$api, this.studyId, auditDetails);
          this.prePopulationEnabled = response.body.prePopulationEnabled;
          this.previousPrePopulationEnabled = _.cloneDeep(this.prePopulationEnabled);
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while updating the survey details");
        }
      );
    },
    hideInfo() {
      this.infoDiv = false;
      this.$el.blur();
    },
    showInfo() {
      this.infoDiv = true;
      this.$el.focus();
    },
    toggleInfo() {
      if (this.infoDiv) {
        this.hideInfo();
      } else {
        this.showInfo();
      }
    },
    changeActivityMode(mode) {
      this.activitySchedulingMode = mode;
      this.setActivityModeIcon(mode);
    },
    setActivityModeIcon(mode) {
      for (const prop in this.activityModeIcon) {
        if (prop === mode) {
          this.activityModeIcon[prop] = MODE_ICON[prop]["selected"];
        } else {
          this.activityModeIcon[prop] = MODE_ICON[prop]["unselected"];
        }
      }
    },
    startAutoSave() {
      this.autoSaveTimer = setInterval(() => {
        this.validateScheduler(true);
      }, this.autoSaveElementTimeout);
    },
    stopAutoSave() {
      clearInterval(this.autoSaveTimer);
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name != "survey-review") {
      this.validateScheduler(true);
    }
    setTimeout(() => {
      next();
    }, 100);
  },
  beforeDestroy() {
    this.stopAutoSave();
  }
};
</script>

<style scoped lang="scss">
.bg-green {
  background-color: #2ecc71 !important;
}

.bt-1 {
  border-top: 1px solid #d3dfe4;
}

.bg-red {
  background-color: #ff7171 !important;
}

.container-style {
  border-radius: 2px;
  background-color: #ffffff;
  color: #666769;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
}

.example {
  margin: 40px 40px 20px 40px;
}
.example-content {
  padding: 20px 40px 20px 40px;
}
.example-header {
  padding: 20px 80px 10px 80px;
  font-weight: bold;
}

.form-control {
  border-radius: 2px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 23px;
}
/* Hide default HTML checkbox */
.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 2px solid #ccc;
}
.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 1px;
  background-color: #ccc;
}
input:checked + .slider {
  border: 2px solid #48bf7a;
}
input:checked + .slider:before {
  content: "";
  background-color: #48bf7a;
}
input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}
input:checked + .slider:before {
  /*content: '✓';*/
  position: absolute;
  color: #2ecc71;
  text-align: center;
  font-size: 20px;
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}
/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}

.footerStyle {
  .row {
    display: block;

    &:after {
      content: "";
      clear: both;
      display: block;
    }
  }
}

.back_link {
  color: #6d6d88 !important;
}

.survey_qs {
  font-weight: 600;
  color: #666769;
}

.activity-mode {
  margin-bottom: 22px;
  display: inline-block;
  & span {
    padding: 16px 28px 16px 11px;
    margin-right: 13px;
    border-radius: 3px;
    border: solid 1px #d3dfe4;
    font-size: 15px;
    &.selected {
      background: #34537d;
      color: #ffffff;
    }
    &:hover {
      cursor: pointer;
    }
    @media screen and (max-width: 768px) {
      margin-right: 5px;
    }
  }
}

.activity-mode-opacity {
  visibility: hidden;
}

.add {
  width: 120px;
  height: 30px;
  border-radius: 4px;
  background-color: #1e8fe1;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  border: none;
}

.left-margin {
  margin-left: 20px;
}

.divider {
  width: 1080px;
  height: 1px;
  background-color: #d3dfe4;
  margin-top: 30px;
}

.email-div {
  margin-top: 30px;
  margin-bottom: 50px;

  .heading {
    font-size: 20px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.6;
    letter-spacing: normal;
    color: #666669;
  }

  .email-div1 {
    margin-top: 20px;

    .txt {
      font-size: 16px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.5;
      letter-spacing: normal;
      color: #666669;
    }

    .txt1 {
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.43;
      letter-spacing: normal;
      color: #666669;
    }
  }

  .email-div2 {
    margin-top: 30px;

    .heading {
      font-size: 16px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.5;
      letter-spacing: normal;
      color: #666669;
    }

    input[type="text"] {
      width: 300px;
      height: 40px;
      border-radius: 3px;
      border: 1px solid #d3dfe4;
      padding: 10px 8px;
    }

    input[type="text"]::placeholder {
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.43;
      letter-spacing: normal;
      color: #c5d1d6;
    }
  }

  .email-div3 {
    margin-top: 20px;

    .txt {
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.43;
      letter-spacing: normal;
      color: #666669;
    }

    .txt-remove {
      font-size: 12px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: normal;
      color: #f16559;
      padding-left: 20px;
      cursor: pointer;
    }
  }
}

.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
  padding-left: 0;
  display: block;
}

.is-danger {
  border-width: 2px;
  border-radius: 5px;
  border-color: #f16559 !important;
}

.recipientBtnDisabled {
  opacity: 0.5;
}

.checkbox_position {
  position: relative;
  top: 2px;
}

.info-circle-div {
  width: 330px;
  background-color: #ffffff;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #666669;
  padding: 15px 18px;
  position: absolute;
  border-radius: 3px;
  margin-left: 270px;
  margin-top: -70px;
  border: 1px solid #dbe5e9;
}
.site-team {
  width: 390px;
  margin-top: -63px;
}

.info-circle {
  padding: 0 15px;
}

.cust-notifi {
  display: inline-block;
}
</style>
